import React from 'react';
import { Button, Input, Text } from '@fragments';

// What a profile creates about and how it speaks: interests, audience and voice, plus —
// for a profile's settings — its memory choice. A visitor's draft also takes the @
// (`withHandle`); a profile's @ is its identity, set by the onboarding.
export default function ProfileForm({ studio: s, form, withHandle = false, withMemory = false, showMemories = false }) {
  const { t } = s;
  return <div className="studio-fields">
    {withHandle && <Input value={form.handle} onInput={form.setHandle} label={t('handleLabel')} aria-label={t('handleLabel')} placeholder="@" maxLength={30} />}
    <Input value={form.interests} onInput={form.setInterests} label={t('nicheLabel')} aria-label={t('nicheLabel')} placeholder={t('nichePlaceholder')} maxLength={300} />
    <Input value={form.audience} onInput={form.setAudience} label={t('audience')} aria-label={t('audience')} maxLength={500} />
    <Input value={form.voice} onInput={form.setVoice} label={t('voice')} aria-label={t('voice')} placeholder={t('voicePlaceholder')} multiline maxLength={3000} />
    {withMemory && <label className="studio-check"><input type="checkbox" checked={form.memory} onChange={e => form.setMemory(e.target.checked)} /><Text.span contrast={8}>{t('memoryEnabled')}</Text.span></label>}
    {showMemories && <Button variant="text" color="overlay" onClick={() => s.setModal('memories')}>{t('memoryTitle')}</Button>}
    {s.error && <Text.p role="alert">{t(`error_${s.error}`, { defaultValue: t('error_generic') })}</Text.p>}
  </div>;
}
